import {observer} from "mobx-react";
import React, {useEffect} from "react";
import {
    ContentExportImport,
    ContentFilter,
    ContentInput,
    ContentInputAndFilter,
    ContentSelectAndCheckBox,
    PaddingFilters
} from "./styled";
import SelectRangeDate from "@dropDesk/presentation/components/dates/select_range_date";
import SelectSearchMain from "@dropDesk/presentation/components/inputs/select_search_main";
import ButtonNew from "@dropDesk/presentation/components/buttons/button_new";
import {useBetween} from "use-between";
import {
    useModalsReportTicket
} from "@dropDesk/presentation/pages/reports/report_ticket_init/report_ticket/ui/modals/handle_change_visible";
import {useInjection} from "inversify-react";
import {AppController} from "@dropDesk/presentation/app/app.controller";
import {filterMap} from "@dropDesk/domain/entities/reports/report_ticket/report_ticket_maps";
import {filtersEnum} from "@dropDesk/domain/entities/reports/report_ticket/report_ticket_enum";
import {Tooltip} from "antd";
import {PeriodEnum} from "@dropDesk/utils/helpers/common";
import {ICONS_DROPDESK} from "@dropDesk/storage/icons/icons.d";
import {UserRole} from "@dropDesk/domain/entities/user/user_enum";
import SelectSearchUser from "@dropDesk/presentation/components/inputs/select_search_users";
import SelectSearchSector from "@dropDesk/presentation/components/inputs/select_search_sectors";
import SelectSearchClient from "@dropDesk/presentation/components/inputs/select_search_clients";
import {ClientEntity} from "@dropDesk/domain/entities/client/client.entity";
import {UserEntity} from "@dropDesk/domain/entities/user/user.entity";
import {SectorEntity} from "@dropDesk/domain/entities/sector/sector.entity";

const SearchBar = observer(
    (
        {
            removeFilter,
            loading,
            client,
            user,
            sector,
            getReportTicket,
            setPeriod,
            period,
            hasDataInGraphics,
            setFilterPerson,
            filterPerson,
            labelPeriodCustom,
            onSelectUser,
            onSelectSector,
            onSelectClient
        }: {
            removeFilter: () => void,
            loading: boolean,
            client: ClientEntity | null,
            user: UserEntity | null,
            sector: SectorEntity | null,
            getReportTicket: () => void,
            period: Array<Date> | null;
            hasDataInGraphics: boolean;
            setFilterPerson: (person: filtersEnum | null) => void
            filterPerson: filtersEnum | null
            setPeriod: (period: Array<Date> | null, label: PeriodEnum) => void
            labelPeriodCustom: PeriodEnum
            onSelectUser: (user: UserEntity | null) => void,
            onSelectSector: (sector: SectorEntity | null) => void,
            onSelectClient: (client: ClientEntity | null) => void,
        }
    ) => {
        const appController = useInjection(AppController);
        const colors = appController.theme.colorScheme;

        const {
            setVisibleModalExportPdf,
            setVisibleModalExport
        } = useBetween(useModalsReportTicket);

        const removeAllFilters = () => {
            removeFilter();
            setFilterPerson(null);
        }


        return (
            <ContentFilter background={colors.onBackground}>
                <ContentInputAndFilter>
                    <ContentInput>
                        <SelectRangeDate
                            size={37}
                            value={period}
                            allowClear={true}
                            onChange={(arrayDate, label) => {
                                setPeriod(arrayDate, label);
                                getReportTicket();
                            }}
                            labelPeriodCustom={labelPeriodCustom}
                        />
                    </ContentInput>
                    <PaddingFilters>
                        <SelectSearchMain<filtersEnum>
                            size={37}
                            width={120}
                            label={"Filtrar por"}
                            placeHolder={"Selecione"}
                            options={filterMap}
                            onChange={(value) => {
                                removeFilter();
                                setFilterPerson(value);
                            }}
                            value={filterPerson ?? null}
                        />
                    </PaddingFilters>
                    {filterPerson === filtersEnum.client && <ContentSelectAndCheckBox>
                        <div style={{display: 'flex', flex: 1, alignItems: 'center', justifyContent: 'center'}}>

                            <SelectSearchClient
                                size={37}
                                useRemoveFilter={!!client}
                                label={'Empresa'}
                                placeHolder={"Selecione a empresa"}
                                handleSelectClient={(value, client) => {
                                    onSelectClient(client ?? null);
                                }}
                                value={client ? {
                                    value: client.id,
                                    label: !!client.socialName ? client.socialName : client.name,
                                } : undefined}
                                disabled={loading}
                            />
                        </div>
                    </ContentSelectAndCheckBox>}

                    {filterPerson === filtersEnum.user &&
                        <ContentSelectAndCheckBox>
                            <div style={{display: 'flex', flex: 1, alignItems: 'center', justifyContent: 'center'}}>
                                <SelectSearchUser
                                    size={37}
                                    useRemoveFilter={!!user}
                                    label={'Atendente'}
                                    placeHolder={"Selecione o atendente"}
                                    handleSelectUser={(value, user) => {
                                        onSelectUser(user ?? null);
                                    }}
                                    value={user ? {value: user.id, label: user.name} : undefined}

                                    role={UserRole.attendant}
                                    disabled={loading}
                                />
                            </div>

                        </ContentSelectAndCheckBox>}

                    {filterPerson === filtersEnum.contacts &&
                        <ContentSelectAndCheckBox>
                            <div style={{display: 'flex', flex: 1, alignItems: 'center', justifyContent: 'center'}}>
                                <SelectSearchUser
                                    size={37}
                                    useRemoveFilter={!!user}
                                    label={'Contato'}
                                    placeHolder={"Selecione o contato"}
                                    handleSelectUser={(value, user) => {
                                        onSelectUser(user ?? null);
                                    }}
                                    disabled={loading}
                                    value={user ? {value: user.id, label: user.name} : undefined}

                                    role={UserRole.userClient}
                                />
                            </div>

                        </ContentSelectAndCheckBox>}

                    {filterPerson === filtersEnum.sector && <ContentSelectAndCheckBox>
                        <div style={{display: 'flex', flex: 1, alignItems: 'center', justifyContent: 'center'}}>
                            <SelectSearchSector
                                size={37}
                                useRemoveFilter={!!sector}
                                label={'Setor'}
                                placeHolder={"Selecione o setor"}
                                handleSelectSector={(value, sector) => {
                                    onSelectSector(sector ?? null);
                                }}
                                value={sector ? {value: sector.id, label: sector?.realName(appController.user!)} : undefined}
                                disabled={loading}
                            />
                        </div>

                    </ContentSelectAndCheckBox>}
                </ContentInputAndFilter>

                <ContentExportImport>
                    <Tooltip title={!hasDataInGraphics ? 'Não possui dados' : ''}>
                        <div>
                            <ButtonNew
                                marginLeft={10}
                                size={37}
                                label={'Exportar gráficos'}
                                onClick={() => {
                                    setVisibleModalExportPdf(true);
                                }}
                                nameLeftIcon={ICONS_DROPDESK.pdf}
                                sizeLeftIcon={15}
                                disabled={loading || !hasDataInGraphics}
                            />
                        </div>
                    </Tooltip>
                    {appController.user?.permissionAdmin &&
                        <Tooltip title={!hasDataInGraphics ? 'Não possui dados' : ''}>
                            <div>
                                <ButtonNew
                                    marginLeft={10}
                                    size={37}
                                    label={'Exportar dados'}
                                    onClick={() => setVisibleModalExport(true)}
                                    nameLeftIcon={ICONS_DROPDESK.excel}
                                    sizeLeftIcon={15}
                                    disabled={loading || !hasDataInGraphics}
                                />
                            </div>
                        </Tooltip>}
                </ContentExportImport>
            </ContentFilter>
        )
    })
export default SearchBar;
